import { asRecordId, composeQuery, getRootCollection } from './queries'

export const listAccounts = () => getRootCollection('accounts')

const whereAssociatedFirstPartyOf = (account) => (query) =>
  query.where(
    'associatedFirstPartyForAccounts',
    'array-contains',
    asRecordId(account)
  )

export const listAssociatedFirstPartyAccounts = (account) =>
  composeQuery(listAccounts, whereAssociatedFirstPartyOf(account))
